import {BatchRequest} from '../../../../services/proto/core/batchRequest';
import {priority} from '@priority-software/priority-proto-api/lib';
import {getAdditionalProps} from '../../../../services/proto/core/loginProps';
import {CachedFields} from '../../../../stores/Form/FormsCache';
import {batchKeys} from '../../../../services/proto/core/constants';

type ResponseType = [
    undefined | priority.netitems.form.IColumnsRs,
    undefined | priority.netitems.form.ISubformsRs,
    undefined | priority.netitems.form.IActionsRs
];

export const fetchMainFormData = async (
    session: string,
    formName: string,
    withAction: boolean = true
) => {
    const batchRequest = new BatchRequest(session);

    batchRequest.addTask({
        key: batchKeys.Columns,
        request: new priority.netitems.form.ColumnsRq({
            Session: session,
            Properties: getAdditionalProps()
        }),
        cacheData: {key: CachedFields.columns, formName}
    });

    batchRequest.addTask({
        key: batchKeys.Subforms,
        request: new priority.netitems.form.SubformsRq({
            Session: session,
            Properties: getAdditionalProps()
        }),
        cacheData: {key: CachedFields.subformsList, formName}
    });
    if (withAction) {
        batchRequest.addTask({
            key: batchKeys.Actions,
            request: new priority.netitems.form.ActionsRq({
                Session: session,
                Properties: getAdditionalProps()
            }),
            cacheData: {key: CachedFields.actions, formName}
        });

        const res = await batchRequest.getData();

        return [res[0]?.Columns, res[1]?.Subforms, res[2]?.Actions] as ResponseType;
    } else {
        const res = await batchRequest.getData();

        return [res[0]?.Columns, res[1]?.Subforms] as Partial<ResponseType>;
    }
};
